<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 shape-primary alpha-4">
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
    </div>
    <div class="container container-lg pt-5">
      <card shadow>
        <div class="search-noresults">
          <section class="normal markdown-section">
            <div class="display-4">V2RayNG（推荐）</div>
            <div class="display-4 mt-4 mb-4">介绍</div>
            <p>V2RayNG是一款适用于掠影的开源Android客户端，支持订阅功能。</p>
            <div class="display-4 mt-4 mb-4">下载安装</div>
            <p>版本:1.7.3 | 更新日期: 2022-06-23</p>
            <p>
              <a
                href="https://www.91freedom.live/img/client/android/v2rayNG_1.8.9.apk"
                target="_blank"
              >本地下载</a> |
              <a
                href="https://github.com/2dust/v2rayNG/releases/download/1.7.20/v2rayNG_1.7.20.apk"
                target="_blank"
              >官方下载</a> |
              <a
                href="https://play.google.com/store/apps/details?id=com.v2ray.ang"
                target="_blank"
              >PlayStore下载</a>
            </p>

            <!-- <ul>
              <li>
                手机浏览器打开
                <a href="https://sstz.info" target="_blank">掠影网络用户中心</a> ，点击已订阅套餐（左上三横线-我的服务，或直接在首页点击产品服务）
              </li>
            </ul>

            <p>
              <img src="/img/client/mobile.png" alt width="300" />
            </p>
            <ul>
              <li>
                在套餐详情中点击
                <strong>通用订阅链</strong> ，订阅信息会自动复制进剪贴板
              </li>
            </ul>
            <p>
              <img src="/img/client/android/v2rayng/012.png" alt />
            </p> -->
            <div class="display-4 mt-4 mb-4">订阅信息</div>
            <div v-if="accounts.length">
              <div v-for="account in accounts" :key="account._id" class="sub-item mb-2">
                <div class="display-6 mt-2 mb-2">{{ account.product.title }}</div>
                <base-button class=" mr-3" size="sm" type="primary" @click="handleCopy(`${subLinks_1}/v1/api/interchangeable/${account.subscription || account._id }`, $event)" >点我复制订阅连接1</base-button>
                <base-button size="sm" type="primary" @click="handleCopy(`${subLinks_2}/v1/api/interchangeable/${account.subscription || account._id }`, $event)" >点我复制订阅连接2</base-button>
              </div>
              <!-- 例子 v2rayng://install-config?url=http%3A%2F%2Fexample.com&name=example
v2rayng://install-config?url 是固定，url=后面是订阅地址 -->
            </div>
            <div v-else>
              <h2 class="display-4" style="font-size: 1.2rem">
                你还没有套餐，
                <router-link :to="{name: 'dashboard-plan'}">立即购买</router-link>
              </h2>
            </div>
            <div class="display-4 mt-4 mb-4">配置教程</div>
            <ul>
              <li>
                点击上面的按钮复制订阅连接，打开刚安装好的V2RayNG，点击
                <strong>左上三横线</strong> 小图标 ，在弹出的窗口中，选择订阅设置
              </li>
            </ul>
            <p>
              <img src="/img/client/android/v2rayng/02.png" alt >
            </p>

            <p>
              <img src="/img/client/android/v2rayng/03.png" alt >
            </p>
            <ul>
              <li>
                进入订阅设置后，点击
                <strong>右上+号</strong>，在弹出窗口填入对应信息，保存
              </li>
            </ul>
            <p>
              <img src="/img/client/android/v2rayng/04.png" alt >
            </p>
            <ul>
              <li>粘贴在网站复制的订阅连接，点击右上角对号保存！</li>
            </ul>
            <p>
              <img src="/img/client/android/v2rayng/05.png" alt >
            </p>
            <p>
              <img src="/img/client/android/v2rayng/06.png" alt >
            </p>
            <ul>
              <li>
                保存后返回V2RayNG主界面，点击
                <strong>右上三点</strong>，选择更新订阅，成功后即可导入订阅套餐对应的所有节点
              </li>
            </ul>
            <p>
              <img src="/img/client/android/v2rayng/07.png" alt >
            </p>
            <p>
              <img src="/img/client/android/v2rayng/08.png" alt >
            </p>
            <p>
              <img src="/img/client/android/v2rayng/09.png" alt >
            </p>

            <ul>
              <li>按需求选择节点后，点击右下角V字图标，第一次运行会跳出允许v2rayNG设置VPN连接的请求，确定后即可开启代理</li>
            </ul>
            <p>
              <img src="/img/client/android/v2rayng/10.png" alt >
            </p>
          </section>
        </div>
      </card>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import clip from '@/utils/clipboard'
export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    accounts() {
      return this.$store.state.server.account
    },
    subLinks_1() {
      return this.$store.state.subLinks_1
    },
    subLinks_2() {
      return this.$store.state.subLinks_2
    }
  },
  mounted() {
    this.loading = true
    this.getAccounts().then(res => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions(['getAccounts']),
    handleCopy(text, event) {
      clip(text, event)
    }
  }

}
</script>
<style scoped>
.product-title{
  width: 120px;
  display:inline-block
}
/* .sub-item{

} */
.search-noresults img {
  max-width: 100%;
}
/* @media only screen and (min-width: 600px) {
 .search-noresults img {
    max-width: 100%;
  }
} */
@media only screen and (min-width: 768px) {
  .search-noresults img {
    max-width: 400px;
  }
}
</style>
